module.exports = __webpack_public_path__ + "static/media/image8.4b1805ef.png";